/* Plus sign helper functions */
export const setLineHeightPlus = (size) => {
    switch (size) {
        case 'L':
            return '32px';
        case 'M':
            return '22px';
        case 'S':
            return '16px';
        default:
            return '32px';
    }
};
/* Title helper functions */
export const setFontSizeTitle = (size, multi) => {
    switch (size) {
        case 'L':
            return 30;
        case 'M':
            if (multi)
                return 14;
            return 20;
        case 'S':
            return 14;
        default:
            return 32;
    }
};
export const setLineHeightTitle = (size, multi) => {
    switch (size) {
        case 'L':
            return '35px';
        case 'M':
            if (multi)
                return '18px';
            return '25px';
        case 'S':
            return '18px';
        default:
            return '35px';
    }
};
/* Description helper functions */
export const setFontSizeDescription = (size) => {
    switch (size) {
        case 'L':
            return 16;
        case 'M':
        case 'S':
            return 14;
        default:
            return 16;
    }
};
export const setLineHeightDescription = (size) => {
    switch (size) {
        case 'L':
            return '20px';
        case 'M':
        case 'S':
            return '18px';
        default:
            return '20px';
    }
};
